import { forwardRef, createElement } from 'react';
const FixedPoint = (props, ref) => {
    const { children, left = 0, top = 0, zIndex } = props;
    return (createElement("div", { ref: ref, style: { position: 'relative' } },
        createElement("div", { style: { position: 'absolute', zIndex, left, top } }, children)));
};
FixedPoint.displayName = 'FixedPoint';
export default forwardRef(FixedPoint);
